import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import RegistrationForm from './components/RegistrationForm';
import './App.css';

function App() {
  return (
    <div className="App" dir="rtl">
      <RegistrationForm />
    </div>
  );
}

export default App;
